// react and mui stuff
import { useNavigate } from "react-router-dom";
import Button from "@mui/joy/Button"
import Sheet from "@mui/joy/Sheet"
import Typography from "@mui/joy/Typography"

// data and stuff
import { imgSrc } from "../../utils/backend";


export default function Trusted() {
  const discord = "https://discord.com/channels/96335850576556032/96335850576556032"
  const nav = useNavigate();

  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "80%" }}>
      {/** Daedalus logo */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <img src={imgSrc("logos/daedalus.png")} alt="Daedalus" height="225px"/>
      </div>
      <br/>
      <div style={{display: "flex", justifyContent: "center"}}>
        <Sheet sx={{ maxWidth: "400px", margin: "10px", padding: "10px", backgroundColor: "var(--semi-transparent)" }}>
          <Typography sx={{ color: "white" }}>
            House sorting is currently reserved for server members with the Trusted role. If you think you've been around long enough, message a mod <a className="daedLink" href={discord} target="_blank" rel="noreferrer">on Discord</a>. Otherwise, come join us so we can get to know you a bit!
          </Typography>
          <br/>
          <Button fullWidth onClick={() => nav("/profile")}>Go Back</Button>
        </Sheet>
      </div>
    </div>
  )
}